export interface DocumentDetails {
  originalName?: string;
  name: string;
  category: string;
  type: string;
  clientName?: string;
  isSpouseDocument?: boolean;
  isDependentDocument?: boolean;
  dimgDocType?: string;
}
